import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\'timeline\'>\n  {{yield\n    (hash\n      Item=(component \'module/timeline/-item\')\n      Comment=(component \'module/timeline/-comment\')\n    )\n  }}\n</div>")